import React, { useState } from 'react';
import Text from 'components/Text';
import {Formik} from 'formik';
import { Button } from 'components/Button';
import bem from 'utils/bem';
import Loader from 'components/Loader';
import { toast } from 'react-hot-toast';

import './index.sass'
import FormikPhoneField from 'forms/fields/PhoneField/FormikPhoneField';

const { block, el } = bem('reset-password-form', 'form');

const defaultValues = {
    customerPhone: '',
};

const ResetPasswordForm = () => {

    const [success, setSuccess ] = useState(false);

    const handleSubmit = (values, form) => {
        const formData = new FormData();

        formData.append('username', values.customerPhone);

        fetch('/reset_password', {
            method: 'POST',
            body: formData
        }).then((promise) => {
            return promise.json();
        }).then((response) => {
            console.log(response);
            if (response.success) {
                setSuccess(true);
                form.resetForm();
            } else {
                const error = response?.error;
                let message = 'Произошла неизвестная ошибка, обратитесь к администратору';
                if (error === 'no_such_user')
                    message = 'Пользователь не найден';
                if (error === 'send_mail_error')
                    message = `Ошибка при отправке письма на почту`;
                toast.error(message);
                form.resetForm();
            }
            form.setSubmitting(false);
        }).catch(err => {
            toast.error('Произошла неизвестная ошибка, обратитесь к администратору');
        });
    };

    if (success) {
        return <div className={block()}>
            <Text>Письмо с паролем отправлено на почту</Text>
        </div>
    }

    const rForm = (form) => {
        return (
            <form className={block()} onSubmit={form.handleSubmit}>
                <div className={el('top-block')}>
                    <div className={el('title')}>
                        <Text serif>Сброс пароля</Text>
                    </div>
                    <div className={el('fields')}>
                        <div className={el('phone')}>
                            <FormikPhoneField />
                        </div>
                    </div>
                </div>
                <div className={el('buttons')}>
                    <Button mod={'gold'}
                            type='submit'
                            disabled={form.isSubmitting}>
                        {'Сбросить'}
                    </Button>
                </div>
            </form>
        )
    }

    return (
        <Formik
            initialValues={defaultValues}
            onSubmit={handleSubmit}
            isInitialValid={false}
            validateOnChange={false}
            validateOnBlur={false}>
            {(form) => rForm(form)}
        </Formik>
    )
};

export default ResetPasswordForm;
